import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              漫画分类
            </h2>
            <p className="text-sm text-foreground-500 mt-1">按类型探索你喜欢的漫画</p>
          </div>

          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 hover:bg-primary-50 transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}